import * as React from 'react';
import { Badge } from './Badge';

interface Props {
  expanded: boolean;
  width: number;
}

export const BetaBlock: React.FC<Props> = (props) => {
  const { expanded, width } = props;
  return (
    <div className="flex flex-col items-center space-y-2 px-2 py-4">
      <Badge />
      <div
        className="text-center transition"
        style={{ width, position: expanded ? 'inherit' : 'absolute', opacity: expanded ? 1 : 0 }}
      >
        <h5>This is a beta feature.</h5>
        <h5>
          <a className="underline" href="mailto:aurelie@bluecargo.io">
            Contact us
          </a>{' '}
          to share your feedback.
        </h5>
      </div>
    </div>
  );
};
BetaBlock.displayName = 'Shipments.BetaBlock';
